module.exports = __webpack_public_path__ + "img/3fe2f3dd157ea901684ee70cecf4d8a6.89bd3c9b.jpg";